import React, { useContext, useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { capitalize } from 'helpers/utils';
import { UilArrowFromRight, UilLeftArrowToLeft } from '@iconscout/react-unicons';
import { useAppContext } from 'providers/AppProvider';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { filterRoutesByPermission } from 'sitemap'; // Función para filtrar rutas por grupos
import Button from 'components/base/Button';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import NavbarTopNav from '../navbar-horizontal/NavbarTopNav';
import NavbarVerticalCollapseProvider from './NavbarVerticalCollapseProvider';
import { routes } from 'sitemap'; // El archivo donde defines todas las rutas
import { useUserContext } from 'layouts/UserContext';

const NavbarVertical: React.FC = () => {
  // Obtener configuración general de la aplicación
  const {
    config: {
      navbarPosition,
      openNavbarVertical,
      navbarVerticalAppearance,
      isNavbarVerticalCollapsed,
    },
    setConfig,
  } = useAppContext();

  const { user } = useUserContext(); // Acceso al usuario desde el contexto (para grupos/roles)
  const { breakpoints } = useBreakpoints();

  // Filtrar rutas según los permisos del usuario
  const filteredRoutes = filterRoutesByPermission(routes, user);

  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className="navbar-vertical"
        expand="lg"
        variant=""
        data-navbar-appearance={
          navbarVerticalAppearance === 'darker' ? 'darker' : ''
        }
      >
        {/* Collapsible wrapper para las rutas */}
        <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">
              {filteredRoutes.map((route) => (
                <Nav.Item key={route.label}>
                  {/* Títulos de secciones del menú */}
                  {!route.labelDisabled && (
                    <>
                      <p className="navbar-vertical-label">
                        {capitalize(route.label)}
                      </p>
                      <hr className="navbar-vertical-line" />
                    </>
                  )}
                  {/* Rutas principales y submenús */}
                  <NavbarVerticalMenu level={1} routes={route.pages} />
                </Nav.Item>
              ))}
            </Nav>

            {/* Menú en dispositivos pequeños cuando usando combo-navbar */}
            {navbarPosition === 'combo' && breakpoints.down('lg') && (
              <div className="move-container">
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr" />
                </div>
                <NavbarTopNav />
              </div>
            )}
          </div>
        </Navbar.Collapse>

        {/* Footer del menú vertical con toggle collapse */}
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed,
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <UilArrowFromRight size={16} className="mb-1" />
            ) : (
              <>
                <UilLeftArrowToLeft size={16} className="mb-1" />
                <span className="ms-2">Collapsed View</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVertical;